export {
  type LANG,
  LANG_ES,
  LANG_EN,
  type LANG_ATTRIBUTE_TAG,
  ES_LANG_ATTRIBUTE_TAG,
  EN_LANG_ATTRIBUTE_TAG,
  ES_TEXT,
  EN_TEXT,
  LANG_TOGGLE_LIST,
  LANGUAGE_CODE_MAP,
} from "./Language";
